import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import AdFileOps from './AdFileOps';
import EditAdButton from './EditAdButton';
import {JsonAdSummary} from '../../ext/lib/types';
import UserContext from '../common/UserContext';
import {useState} from 'react';
import {jsonDateTimeFormat} from '../../ext/lib/temporal';
import {handleResponse} from '../../ext/common/rest-api-helper';
import * as R from 'ramda';

type Props = {ad: JsonAdSummary}

const ApproveAdActions: React.FC<Props> = ({ad}: Props) => {
  const {apiToken} = React.useContext(UserContext);
  const [isApproved, setIsApproved] = useState(Boolean(ad.approvedAt));

  async function handleApprovalChange(e: React.ChangeEvent<HTMLInputElement>): Promise<void> {
    const changeEventAdKey = (e: React.ChangeEvent<HTMLInputElement>) => ({
      adUser: e.target.dataset.user as string,
      adKey: e.target.dataset.key as string
    });

    function setApproval(adUser: string, adKey: string, isApproved: boolean): Promise<void> {
      return fetch(`/api/v1/requests/${btoa(adUser)}/${adKey}`, {
        method: 'PATCH',
        headers: {
          'Authorization': apiToken || 'unknown-token',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(
          isApproved
           ? {approvedAt: jsonDateTimeFormat(new Date())}
           : {approvedAt: ''}
        )
      }).then(R.pipe(
        handleResponse as (_: Response) => Promise<void>,
        R.otherwise(err => {
          console.error('Unable to set ad approval: %o', err);
          alert('Unable to set ad approval. Try again or contact support');
        })
      ));
    }

    const {adUser, adKey} = changeEventAdKey(e);
    const checked = R.path(['target', 'checked'], e) as boolean;
    setIsApproved(checked);
    return setApproval(adUser, adKey, checked);
  }

  return (<>
    <FormControlLabel
      label="Approved"
      control={
        <Switch
          checked={isApproved}
          color="primary"
          inputProps={{
            // @ts-ignore
            'data-user': ad.userEmailAddress,
            'data-key': ad.adKey
          }}
          onChange={handleApprovalChange}
        />
      }
    />
    <AdFileOps
      adKey={ad.adKey}
      adFileKey={ad.adFileKey}
      userAuthToken={apiToken || 'unknown-token'}
      userEmailAddress={ad.userEmailAddress}
    />
    <EditAdButton
      style={{marginLeft: '1em'}}
      adKey={ad.adKey} />
  </>);
};
export default ApproveAdActions;
